import { ReactComponent as emptyCart } from './empty-cart.svg';
import { ReactComponent as emptyResult } from './empty-result.svg';

export const svgImages = {
  emptyCart,
  emptyResult
};
